export default {
  LIST(state, data) {
    state.orgMonitorings = data
  },
  GET(state, data) {
    state.orgMonitoring = data
  },
  UPDATE(state, value) {
    state.orgMonitoring = {
      ...value,
    }
  },
  FRESH(state) {
    state.orgMonitoring = {
      id: null,
      period: null,
      quarter: null,
      file: null,
    }
  },
}
